/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type StripeEmbeddedCheckout = {
  /**
   * Client secret Stripe.js uses to mount embedded Checkout
   */
  clientSecret: string;
  /**
   * Stripe publishable key used to load Stripe.js
   */
  publishableKey: string;
};

/** @internal */
export const StripeEmbeddedCheckout$inboundSchema: z.ZodMiniType<
  StripeEmbeddedCheckout,
  unknown
> = z.pipe(
  z.object({
    client_secret: z.string(),
    publishable_key: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_secret": "clientSecret",
      "publishable_key": "publishableKey",
    });
  }),
);

export function stripeEmbeddedCheckoutFromJSON(
  jsonString: string,
): SafeParseResult<StripeEmbeddedCheckout, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => StripeEmbeddedCheckout$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'StripeEmbeddedCheckout' from JSON`,
  );
}
